import { normalizeWidgetTheme, APIURL, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getNoDataHTML, getSymbolDropdown, getTraderSMCardHTML, getWidgetDataURI, isEmptyWidgetData, apiGet, toggleWidgetTheme, updateSelectedSymbolInDropdown, isHeaderPinned, getHeaderPinStateClass, getHeaderPinButtonHTML, setupHeaderPin } from './../../helpers';
import { WidgetConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';

export class TraderverseTopNews {
    private container: HTMLElement;
    private config: WidgetConfig;
    private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
    private updateInterval: number | null = null;
    private shadowRoot: ShadowRoot;
    private currentData: any = null;
    private widgetResizeObserver: ResizeObserver | null = null;
    private lastFetchedAt: Date | null = null;
    private widgetIndex: number = 0;

    constructor(config: WidgetConfig) {
        this.config = { ...this.getDefaultConfig(), ...config };
        this.config.theme = normalizeWidgetTheme(this.config.theme);
        this.container = this.resolveContainer(config.container);

        if ((this.container as any).shadowRoot) {
            this.shadowRoot = (this.container as any).shadowRoot;
        } else {
            this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
        }
        this.init();

        this.widgetResizeObserver = new ResizeObserver(() => {
            window.requestAnimationFrame(() => this.updateDisplay());
        });
        setTimeout(() => {
            const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
            if (widget) this.widgetResizeObserver?.observe(widget);
        }, 0);
    }

    private fetchSymbols(): Array<{ value: string; label: string }> {
        return [
            { label: 'AAPL', value: 'AAPL' }, { label: 'MSFT', value: 'MSFT' },
            { label: 'GOOGL', value: 'GOOGL' }, { label: 'AMZN', value: 'AMZN' },
            { label: 'NVDA', value: 'NVDA' }, { label: 'META', value: 'META' },
            { label: 'TSLA', value: 'TSLA' }, { label: 'AVGO', value: 'AVGO' },
            { label: 'PEP', value: 'PEP' }, { label: 'COST', value: 'COST' }
        ];
    }

    private getDefaultConfig(): Partial<WidgetConfig> {
        const symbols = this.fetchSymbols();
        return {
      headerPinned: true,
            symbol: symbols[0].value,
            theme: 'default-dark',
            width: '100%',
            height: '400px',
            autosize: true
        };
    }

    private resolveContainer(container: string | HTMLElement): HTMLElement {
        if (typeof container === 'string') {
            const el = document.getElementById(container) || document.querySelector(container);
            if (!el) throw new Error(`Container not found: ${container}`);
            return el as HTMLElement;
        }
        return container;
    }

    private async init(): Promise<void> {
        if (!this.config.symbol) this.config.symbol = this.fetchSymbols()[0].value;
        this.createWidget();
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        if (widget) widget.classList.add('loading');
        this.attachStyles();
        await this.setupChart();
        if (widget) widget.classList.remove('loading');
        this.emit('ready', {});
        cancelSelectEvent(this.shadowRoot);
        this.config.onReady?.();
    }

    private createWidget(): void {
        let themeClass = 'defaultDarkMode';
        let dataTheme = 'default-dark';
        
        if (this.config.theme === 'white') {
            themeClass = 'whiteMode';
            dataTheme = 'white';
        } else if (this.config.theme === 'black') {
            themeClass = 'blackMode';
            dataTheme = 'black';
        } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
        const symbolOptions = this.fetchSymbols()
            .map(s => `<option value="${s.value}">${s.label}</option>`).join('');

        const widgetHtml = `
        <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width};height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-testing-id="top-news-widget-${this.widgetIndex}" data-theme="${dataTheme}">
          <div class="headTop">
            <h4 class="title news">${this.getTitleIconSvg()} News Sentiment</h4>
                        <div class="actionCol">${getHeaderPinButtonHTML(this.config)}<tooltip-wrapper id="lastUpdatedTooltip"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.625 6.625C0.625 7.41293 0.780195 8.19315 1.08172 8.9211C1.38325 9.64905 1.82521 10.3105 2.38236 10.8676C2.93951 11.4248 3.60095 11.8667 4.3289 12.1683C5.05685 12.4698 5.83707 12.625 6.625 12.625C7.41293 12.625 8.19315 12.4698 8.9211 12.1683C9.64905 11.8667 10.3105 11.4248 10.8676 10.8676C11.4248 10.3105 11.8667 9.64905 12.1683 8.9211C12.4698 8.19315 12.625 7.41293 12.625 6.625C12.625 5.0337 11.9929 3.50758 10.8676 2.38236C9.74242 1.25714 8.2163 0.625 6.625 0.625C5.0337 0.625 3.50758 1.25714 2.38236 2.38236C1.25714 3.50758 0.625 5.0337 0.625 6.625Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.625 3.2915V6.62484L8.625 8.62484" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/> </svg><tooltip><span>Last Updated</span><strong>N/A</strong></tooltip></tooltip-wrapper><i class="pi pi-ellipsis-v"></i></div>
          </div>
          <div class="inBody">
          <div class="optionsRow">
            <div class="item">
            <select id="intervalSelect" class="intervalSelect" data-testing-id="interval-select">
                                <option value="today" >today</option>
                                <option value="thisweek" selected>This Week</option>
                                <option value="thismonth">This Month</option>
                            </select>
            </div>

            </div>

            <div class="chartDv">
                <div id="sentimentContainer" style="margin-bottom: 30px;"></div>
                <div class="topNewsCards cardsCarousel" id="keyMarticsContainer"></div>
            </div>
                        
          </div>
        </div>
    `;
        this.shadowRoot.innerHTML = widgetHtml;
    setupHeaderPin(this.shadowRoot, this.config);

        const select = this.shadowRoot.querySelector('#intervalSelect') as HTMLSelectElement | null;
        if (select) {
            select.addEventListener('change', () => {
                this.setupChart();
            });
        }
    }

    private async attachStyles(): Promise<void> {
        try {
            const styleEl = await getCSSStyles();
            this.shadowRoot.appendChild(styleEl);
        } catch (err) {
            console.error('Failed to load CSS file:', err);
        }
    }

    private async setupChart(): Promise<void> {
        const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        try {
            const interval = (this.shadowRoot.querySelector('#intervalSelect') as HTMLSelectElement | null)?.value || 'thisweek';
            const payload = {
                interval,
                raw_type: "raw"
            };
            const res = await apiGet({
                method: "POST",
                url: `${APIURL}/v1/news_stats`,
                body: payload,
            });

            if (!res.ok) {
                const errorText = await res.text();
                throw new Error(`API Error: ${res.status} ${res.statusText} - ${errorText}`);
            }

            const data = await res.json();

            if (!data || typeof data !== 'object') {
                throw new Error("Invalid data received from API");
            }

            this.currentData = data;
            const fromApi = (data as any)?.last_updated_at;
            this.lastFetchedAt = fromApi ? new Date(fromApi) : new Date();
            
            if (!this.currentData?.data) {
                widgetBox?.removeAttribute('data-testing-id');
            }
            
            try {
                const sentRes = await apiGet({
                    method: 'POST',
                    url: `${APIURL}/v1/overall_sentiment`,
                    body: { interval },
                });
                if (sentRes.ok) {
                    const sentData = await sentRes.json();
                    this.currentData.sentiment = sentData?.data || sentData;
                }
            } catch (e) {
                console.warn('Failed to fetch sentiment data:', e);
            }
            this.updateDisplay();
            this.emit('dataUpdate', this.currentData);
        } catch (err) {
            console.error("Error fetching chart data:", err);
            widgetBox?.removeAttribute('data-testing-id');
        }
    }

    private formatLastUpdated(date: Date): string {
        const options: Intl.DateTimeFormatOptions = {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'America/New_York',
        };
        return date.toLocaleString('en-US', options).replace(',', '').replace(/\//g, '-') + ' EST';
    }

    private updateLastUpdatedTooltip(): void {
        const lastUpdated = this.lastFetchedAt ? this.formatLastUpdated(this.lastFetchedAt) : 'N/A';
        const tooltip = this.shadowRoot.querySelector('#lastUpdatedTooltip tooltip strong');
        if (tooltip) tooltip.innerHTML = lastUpdated.replace(' ', '<br>');
    }

    private updateDisplay(): void {
        this.updateLastUpdatedTooltip();
        const container = this.shadowRoot.querySelector('#keyMarticsContainer') as HTMLElement;
        if (!container) return;
        if (this.currentData == null) {
            setTimeout(() => this.updateDisplay(), 100);
            return;
        }
        if (isEmptyWidgetData(this.currentData?.data)) {
            container.innerHTML = getNoDataHTML();
            return;
        }
        try {
            if (this.currentData.sentiment) {
                this.renderSentimentAnalysis({
                    overallSentiment: this.currentData.sentiment?.overall || this.currentData.sentiment?.overall_sentiment || 'Neutral',
                    positive: this.currentData.sentiment?.positive_percentage || this.currentData.sentiment?.positive || 0,
                    neutral: this.currentData.sentiment?.neutral_percentage || this.currentData.sentiment?.neutral || 0,
                    negative: this.currentData.sentiment?.negative_percentage || this.currentData.sentiment?.negative || 0
                });
            }
        } catch (e) {
            console.warn('Failed to render sentiment:', e);
        }

        this.renderNews(this.currentData.data);
    }

    private renderSentimentAnalysis(sentimentData: any): void {
        const parent = this.shadowRoot.querySelector('#sentimentContainer') as HTMLElement | null;
        if (!parent) return;

        const overall = sentimentData?.overallSentiment || 'Neutral';
        const pos = Number(sentimentData?.positive ?? 0);
        const neu = Number(sentimentData?.neutral ?? 0);
        const neg = Number(sentimentData?.negative ?? 0);

        const sentimentEmoji = overall === 'Positive' ? '😊' : overall === 'Negative' ? '😞' : '😐';

        const html = `
                <div class="sentimentAnalysis">
                    <div class="header">
                        <h2> ${overall} <span>${sentimentEmoji}</span> </h2>
                        <p class="overallSentimentLabel">Overall Sentiment</p>
                    </div>

                    <div class="barContainer">
                            <div class="bar negative" style="--width: ${neg}%;"></div>
                            <div class="bar neutral" style="--width: ${neu}%;"></div>
                            <div class="bar positive" style="--width: ${pos}%;"></div>
                    </div>

                    <div class="stats">
                        <div class="stat negative">
                            <p>Negative</p>
                            <p class="percentage">${neg.toFixed(2)}%</p>
                        </div>
                                    <div class="stat neutral">
                                        <p>Neutral</p>
                                        <p class="percentage">${neu.toFixed(2)}%</p>
                                    </div>
                        <div class="stat positive">
                            <p>Positive</p>
                            <p class="percentage">${pos.toFixed(2)}%</p>
                        </div>
                    </div>
                </div>
                `;

        parent.innerHTML = html;
    }

    private formatValue(value: number): string {
        if (value === null || value === undefined || isNaN(value)) return '-';
        return Number(value).toLocaleString('en-US');
    }

    private async renderNews(data: any): Promise<void> {
        const container = this.shadowRoot.querySelector('#keyMarticsContainer');
        const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        if (!container || !data) return;
        
        // Render a simple static list of cards instead of using Splide slider
        container.innerHTML = '';
        const listRoot = document.createElement('div');
        listRoot.className = 'cardsList';
        container.appendChild(listRoot);

        const cards = [
            { label: "News", value: data.news_count, change: data.agg_change, icon: "📰", key: "news" },
            { label: "Symbols", value: data.symbol_count, change: data.symbol_change, icon: "💹", key: "symbols" },
            { label: "Positive", value: data.positive_count, change: data.positive_change, icon: "📈", color: "#00ff91", key: "positive" },
            { label: "Negative", value: data.negative_count, change: data.negative_change, icon: "📉", color: "#ff4d4d", key: "negative" }
        ];

        cards.forEach((item, idx) => {
            const change = item.change ?? 0;
            const isPositive = change >= 0;
            const color = item.color ?? (isPositive ? '#00ff91' : '#ff4d4d');

            const cardWrap = document.createElement('div');
            cardWrap.className = 'cryptoCard';
            cardWrap.setAttribute('data-testing-id', `top-news-card-${idx}`);
            cardWrap.setAttribute('data-card-type', item.key);
            cardWrap.innerHTML = `
                <span class="bg"></span>
                <div class="textDv">
                    <h2 data-testing-id="top-news-card-${idx}-label">${item.label}</h2>
                    <div class="valueWrapper">
                        <h3 data-testing-id="top-news-card-${idx}-value">${this.formatValue(item.value)}</h3>
                        <span style="color:${color}" data-testing-id="top-news-card-${idx}-change">${change.toFixed(2)}%</span>
                    </div>
                </div>
            `;
            listRoot.appendChild(cardWrap);
        });
    }

    public on(type: WidgetEventType, handler: WidgetEventHandler): void {
        if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
        this.eventHandlers.get(type)!.push(handler);
    }
    public off(type: WidgetEventType, handler: WidgetEventHandler): void {
        const list = this.eventHandlers.get(type);
        if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
    }

    public async getWidgetImage(): Promise<string> {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        return await getWidgetDataURI(widget);
    }
  
    public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
        if (!this.shadowRoot) return;
      
        this.config.theme = toggleWidgetTheme(
            this.shadowRoot,
            theme
        ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
      
        this.updateDisplay();
    }
    public destroy(): void {
        if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
        if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
        this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
    }
    private emit(type: WidgetEventType, data: any): void {
        const handlers = this.eventHandlers.get(type);
        if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
    }
    private getTitleIconSvg(): string {
      return `<svg width="27" height="22" viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M22.6125 22H4.3875C3.26681 22.0001 2.18858 21.5634 1.37399 20.7794C0.559395 19.9955 0.0701982 18.9239 0.00675018 17.7843L2.29482e-08 17.5312V3.09375C-9.45295e-05 2.30983 0.291999 1.5551 0.817249 0.982089C1.3425 0.409082 2.06173 0.0605304 2.8296 0.00687518L3.0375 2.33732e-08H19.9125C20.6822 -9.62801e-05 21.4232 0.297406 21.9858 0.832383C22.5484 1.36736 22.8906 2.09991 22.9433 2.882L22.95 3.09375V4.125H23.9625C24.7322 4.1249 25.4732 4.42241 26.0358 4.95738C26.5984 5.49236 26.9406 6.22491 26.9933 7.007L27 7.21875V17.5312C27.0001 18.6727 26.5713 19.7709 25.8016 20.6006C25.032 21.4302 23.9798 21.9285 22.8609 21.9931L22.6125 22ZM4.3875 19.9375H22.6125C23.2056 19.9374 23.777 19.7102 24.2132 19.3008C24.6494 18.8914 24.9184 18.33 24.9669 17.7279L24.975 17.5312V7.21875C24.975 6.96955 24.8864 6.72878 24.7256 6.54097C24.5647 6.35316 24.3426 6.23102 24.1002 6.19712L23.9625 6.1875H22.95V16.8438C22.95 17.093 22.8614 17.3337 22.7006 17.5215C22.5397 17.7093 22.3176 17.8315 22.0752 17.8654L21.9375 17.875C21.6928 17.875 21.4564 17.7847 21.272 17.6209C21.0876 17.4571 20.9677 17.2309 20.9345 16.984L20.925 16.8438V3.09375C20.925 2.84455 20.8364 2.60378 20.6756 2.41597C20.5147 2.22816 20.2926 2.10602 20.0502 2.07212L19.9125 2.0625H3.0375C2.79283 2.06251 2.55644 2.15276 2.37204 2.31656C2.18765 2.48035 2.06773 2.70661 2.03445 2.9535L2.025 3.09375V17.5312C2.02502 18.1351 2.24798 18.7169 2.64962 19.1612C3.05125 19.6054 3.6022 19.8796 4.1931 19.9292L4.3875 19.9375ZM13.8321 14.4375H17.8902C18.1467 14.4376 18.3937 14.5368 18.5811 14.7152C18.7686 14.8936 18.8826 15.1378 18.9 15.3985C18.9175 15.6591 18.8372 15.9169 18.6753 16.1195C18.5134 16.3222 18.282 16.4548 18.0279 16.4904L17.8902 16.5H13.8321C13.5756 16.4999 13.3286 16.4007 13.1412 16.2223C12.9537 16.0439 12.8398 15.7997 12.8223 15.539C12.8048 15.2784 12.8851 15.0206 13.047 14.818C13.2089 14.6153 13.4403 14.4827 13.6944 14.4471L13.8321 14.4375ZM9.77805 9.63188C10.0466 9.63188 10.3041 9.74052 10.494 9.93392C10.6839 10.1273 10.7906 10.3896 10.7906 10.6631V15.4688C10.7906 15.7423 10.6839 16.0046 10.494 16.198C10.3041 16.3914 10.0466 16.5 9.77805 16.5H5.0598C4.79127 16.5 4.53373 16.3914 4.34385 16.198C4.15397 16.0046 4.0473 15.7423 4.0473 15.4688V10.6631C4.0473 10.3896 4.15397 10.1273 4.34385 9.93392C4.53373 9.74052 4.79127 9.63188 5.0598 9.63188H9.77805ZM8.76555 11.6944H6.0723V14.4375H8.76555V11.6944ZM13.8321 9.63188H17.8902C18.1467 9.63196 18.3937 9.73121 18.5811 9.90959C18.7686 10.088 18.8826 10.3322 18.9 10.5928C18.9175 10.8535 18.8372 11.1112 18.6753 11.3139C18.5134 11.5166 18.282 11.6491 18.0279 11.6848L17.8902 11.6944H13.8321C13.5737 11.6971 13.3242 11.599 13.1344 11.4204C12.9447 11.2417 12.8293 10.996 12.8117 10.7334C12.7941 10.4709 12.8757 10.2114 13.0398 10.0082C13.2039 9.8049 13.4381 9.67324 13.6944 9.64012L13.8321 9.63188ZM5.0598 4.81525H17.8902C18.1486 4.81257 18.3981 4.9106 18.5879 5.08925C18.7776 5.2679 18.893 5.51366 18.9106 5.7762C18.9282 6.03875 18.8466 6.29821 18.6825 6.50147C18.5184 6.70472 18.2842 6.83639 18.0279 6.8695L17.8902 6.87775H5.0598C4.80327 6.87767 4.55633 6.77841 4.36888 6.60004C4.18143 6.42166 4.06745 6.17746 4.04997 5.91679C4.03248 5.65612 4.1128 5.3984 4.27468 5.19571C4.43657 4.99303 4.66796 4.86049 4.9221 4.82487L5.0598 4.81525Z" fill="currentColor"/> </svg>`;
    }

}

declare global { interface Window { TraderverseTopNews: typeof TraderverseTopNews; } }
if (typeof window !== 'undefined') { window.TraderverseTopNews = TraderverseTopNews; }